import { render, staticRenderFns } from "./PriceSettingV2.vue?vue&type=template&id=f9b8abd8"
import script from "./PriceSettingV2.vue?vue&type=script&lang=js"
export * from "./PriceSettingV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports